export default defineNuxtPlugin({
    name: 'tracking',
    setup(nuxtApp) {
        if (useRuntimeConfig().public.googleTagManager.disabled) return;

        const router = useRouter();
        const { trackPageView } = useTracking();

        router.afterEach(to => {
            const { trackLogState } = useTracking();
            trackLogState(to);
        });

        nuxtApp.hook('page:finish', () => {
            trackPageView();
        });
    },
});
